import { RouteObject } from 'react-router-dom';

// Import components directly instead of lazy loading to avoid routing issues
import HomePage from '../pages/home/page';
import LoginPage from '../pages/auth/login';
import RegisterPage from '../pages/auth/register';
import GuidelinePage from '../pages/guideline/page';
import AppraisalGuidelinesPage from '../pages/appraisal-guidelines/page';
import PricingPage from '../pages/pricing/page';
import ResourcesPage from '../pages/resources/page';
import SupportPage from '../pages/support/page';
import MarketingPage from '../pages/marketing/page';
import SuccessPage from '../pages/success/page';
import PrivacyPage from '../pages/privacy/page';
import TermsPage from '../pages/terms/page';
import NotFoundPage from '../pages/NotFound';
import AssessorDirectoryPage from '../pages/assessor-directory/page';
import AppraisalGuidelinePage from '../pages/appraisal-guideline/page';
import StatesPage from '../pages/states/page';
import SearchPage from '../pages/search/page';
import ContactPage from '../pages/contact/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/auth/login',
    element: <LoginPage />,
  },
  {
    path: '/register',
    element: <RegisterPage />,
  },
  {
    path: '/auth/register',
    element: <RegisterPage />,
  },
  {
    path: '/guideline/:id',
    element: <GuidelinePage />,
  },
  {
    path: '/appraisal-guidelines',
    element: <AppraisalGuidelinesPage />,
  },
  {
    path: '/appraisal-guideline/:id',
    element: <AppraisalGuidelinePage />,
  },
  {
    path: '/pricing',
    element: <PricingPage />,
  },
  {
    path: '/resources',
    element: <ResourcesPage />,
  },
  {
    path: '/support',
    element: <SupportPage />,
  },
  {
    path: '/marketing',
    element: <MarketingPage />,
  },
  {
    path: '/success',
    element: <SuccessPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/assessor-directory',
    element: <AssessorDirectoryPage />,
  },
  {
    path: '/states',
    element: <StatesPage />,
  },
  {
    path: '/search',
    element: <SearchPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/404',
    element: <NotFoundPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
